import { AppContext } from '@prisjakt/ui-app-context';
import PropTypes from 'prop-types';
import React, { memo, useContext } from 'react';

const makeImageUrl = (cdnUrl, name) => `${cdnUrl}g/ftg_logos/store_${name}.png`;

const CdnImage = ({ name, alt, logoUrl, width, height }) => {
  const { market = { imageCdnUrl: '', code: '' } } = useContext(AppContext);
  const imageUrl = logoUrl || makeImageUrl(market.imageCdnUrl, name);

  const styles = {};
  if (height !== undefined) styles.height = height;

  return (
    <picture alt={alt}>
      {/* <source
        srcSet={makeImageUrl(
          market.imageCdnUrl,
          market.code,
          type,
          name,
          width,
          'webp'
        )}
        type="image/webp"
      /> */}
      {/* Safari fallback */}
      <source srcSet={imageUrl} type="image/png" />
      {/* IE fallback */}
      <img src={imageUrl} alt={alt} width={width} style={styles} />
    </picture>
  );
};

export const cdnImageTypes = {
  store: 'store',
};

const { string, number, oneOf, oneOfType } = PropTypes;

CdnImage.propTypes = {
  type: oneOf(Object.values(cdnImageTypes)).isRequired,
  name: oneOfType([string, number]).isRequired,
  height: number,
  width: number,
  logoUrl: string,
  alt: string,
};

CdnImage.defaultProps = {
  alt: undefined,
  logoUrl: undefined,
  height: undefined,
  width: undefined,
};

export default memo(CdnImage);
